import { Component, Input, OnInit } from '@angular/core';
import { DurationRangeService } from '@app-core/services/duration-range/duration-range.service';
import { CourierNotificationComponent } from '@app-shared/components/courier-notification/courier-notification.component';
import { CLIENT_CONFIG } from '@config/config';

@Component({
  selector: 'app-notification-component',
  templateUrl: './notification-component.component.html',
  styleUrls: ['./notification-component.component.scss'],
})
export class NotificationComponent implements OnInit {
  public clientConfig = CLIENT_CONFIG;
  public showSuprSendNotification: boolean = false;
  public courierNotificationComponent: Promise<Component | typeof CourierNotificationComponent>;
  @Input() user_distinct_id: string;
  @Input() user_subscriberId: string;

  constructor(public durationService: DurationRangeService) {}

  ngOnInit(): void {
    this.showSuprSendNotification = this.durationService?.showSuprsendNotification || false;
    if (!this.showSuprSendNotification) {
      this.courierNotificationComponent = import('@app-shared/components/courier-notification/courier-notification.component').then(
        (module) => module.CourierNotificationComponent
      );
    }
  }
}
